export const getBrand = (state) => state.getIn(['page', 'brand']);
